
export function parseMessageInput(html :string) :{text:string, entities:any[]} {
     // Tạo một DOM element tạm thời
     const tempDiv = document.createElement("div");
     // Gán chuỗi HTML vào nội dung của div
     tempDiv.innerHTML = html;
     // Trích xuất nội dung văn bản
     //return tempDiv.textContent || tempDiv.innerText || "";

    return {text:tempDiv.textContent || tempDiv.innerText || "",entities:[]};
}